import { ActiveIngredientForAdminMedicineModel } from "../activeIngredient/activeIngredientForAdminMedicineModel";
import { InactiveIngredientModel } from "../inactiveIngredient/inactiveIngredientModel";
import { FileModel } from "../../models/fileModel";
import { AdminMedicineSpecificationModel } from './adminMedicineSpecificationModel';
import { PregnancyAndBreastfeedingModel } from './pregnancyAndBreastfeedingModel';
import { IngredientSideEffectModel } from "../sideEffect";
import { DosageContentModel } from "../dosage";
import { SafetyDataModel } from "./safetyDataModel";
import { ATCCodeModel } from "../atcCode";
import { DriveAndMachineModel } from './driveAndMachineModel';
import { MedicineContentModel } from './medicineContent';
import { MedicineOverviewContentModel } from "./medicineOverviewContentModel";
import { MedicineInteractionContentModel } from "./medicineInteractionContentModel";

export class AdminMedicineModel {
  public medicineId: number;
  public brandName: string;
  public medicineNumber: string;
  public emaProductNumber: string;
  public additionalTitle: string;
  public overviewSummary: string;
  public overviewAboutMedicine: string;
  public overviewBeforeIntake: string;
  public overviewDosage: string;
  public overviewSideEffects: string;
  public overviewSafetyData: string;
  public overviewAdditionalInfo: string;
  public fullDescription: string;
  public manufacturerId?: number;
  public authorisationHolderId?: number;
  public manufacturerName: string;
  public authorisationHolderName: string;
  public atcCodeId: number;
  public isWithSideEffects: boolean;
  public sideEffect: IngredientSideEffectModel;
  public isWithDosageContent: boolean;
  public dosageContent: DosageContentModel;
  public isWithPregnancy: boolean;
  public pregnancyAndBreastfeeding: PregnancyAndBreastfeedingModel;
  public isWithSafetyData: boolean;
  public safetyData: SafetyDataModel;
  public specification: AdminMedicineSpecificationModel;
  public activeIngredients: Array<ActiveIngredientForAdminMedicineModel>;
  public inactiveIngredients: Array<InactiveIngredientModel>;
  public leaflets: Array<FileModel>;
  public atcCode?: ATCCodeModel;
  public isWithDriveAndMachine: boolean;
  public driveAndMachine: DriveAndMachineModel;
  public medicineContent: Array<MedicineContentModel>;
  public medicineOverviewContent: Array<MedicineOverviewContentModel>;
  public isWithInteractionContent: boolean;
  public medicineInteractionContents: Array<MedicineInteractionContentModel>;
  public dataSourceTypeId: number;
  public medicineDataURL: string;
  public authorisationStatusId: number;
}